import { Card, Typography, Row, Col } from 'antd';
import { MailOutlined, IdcardOutlined } from '@ant-design/icons';
import ContactInfoSection from '../sections/ContactInfoSection';
import OwnershipCard from './OwnershipCard';

const { Title } = Typography;

const CandidateHeader = ({ candidate, onViewOwnershipHistory, brandColor = '#667eea' }) => {
  const gradientStyle = {
    marginBottom: '24px',
    background: brandColor ? `linear-gradient(135deg, ${brandColor} 0%, ${brandColor} 100%)` : '#667eea',
    backgroundImage: brandColor ? `linear-gradient(135deg, ${brandColor} 0%, color-mix(in oklch, ${brandColor}, black 25%) 100%)` : undefined,
    border: 'none',
    borderRadius: '16px',
    boxShadow: `0 8px 24px ${brandColor}26`
  };

  return (
    <Card 
      style={gradientStyle}
      bodyStyle={{ padding: '32px' }}
    >
      <Row>
        <Col span={14}>
          <div>
              <Title level={2} style={{ margin: '0 0 12px 0', color: 'white' }}>
                {`${candidate.firstName} ${candidate.lastName}`}
              </Title>
              <Row gutter={12}>
                <Col span={10}>
                  <ContactInfoSection
                    contactInfo={candidate.contactInfo}
                    type="email"
                    label="Emails"
                    icon={<MailOutlined />}
                  />
                </Col>
                <Col span={8}>
                  <ContactInfoSection
                    contactInfo={candidate.contactInfo}
                    type="atsId"
                    label="ATS IDs"
                    icon={<IdcardOutlined />}
                  />
                </Col>
              </Row>
          </div>
        </Col>
        <Col span={10} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <OwnershipCard 
            candidate={candidate}
            onViewHistory={onViewOwnershipHistory}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default CandidateHeader;